import { TieringConfig } from '@trimble/types';
import { JSX, Match, Switch } from 'solid-js';
import { TierLock } from '../TierLock';

export const OptionalTierLock = (props: {
  children: JSX.Element;
  preserveWidth?: boolean;
  options?: TieringConfig;
}): JSX.Element => (
  <Switch>
    <Match when={!!props.options}>
      <TierLock
        preserveWidth={props.preserveWidth}
        targetFeature={props.options!.featureName}
        options={props.options!}
      >
        {props.children}
      </TierLock>
    </Match>
    <Match when={!props.options}>{props.children}</Match>
  </Switch>
);
